// extracted by mini-css-extract-plugin
module.exports = {"contacts":"Contacts_contacts__3RnRo","contactsTitle":"Contacts_contactsTitle__1d9F9","contactTitle":"Contacts_contactTitle__1hkt5","contact":"Contacts_contact__2dPhU"};